import { Pagination } from "@mui/material";
import { CaretLeftIcon, Cross2Icon } from "@radix-ui/react-icons";
import { UserMultipleIcon } from "hugeicons-react";
import { Link2, MoreHorizontal, Plus, Search } from "lucide-react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { NavLink, useParams } from "react-router-dom";
import { HOME } from "../../Utils/Utils";
import {
  DISABLE_TEAM,
  LISTE_EQUIPE_COORDO,
  SUPPRIMER_EQUIPE,
} from "../../Utils/constant";
import { Loader } from "../../components/Widget/Loader";
import { AddTeam } from "../../components/utilisateur/AddTeam";
import { AssociateTeam } from "../../components/utilisateur/AssociateTeam";
import { UpdateTeam } from "../../components/utilisateur/UpdateTeam";
import { deleteOne, disable } from "../../services/service";
import { useEquipeStore } from "../../store/EquipeStore";

export const Equipe = () => {
  const equipe = useEquipeStore();
  const { id, name } = useParams();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    equipe.getEquipePrestataire(
      LISTE_EQUIPE_COORDO + "/" + id + `?param=&page=0&size=10`,
    );
  }, []);

  const more = async (page) => {
    equipe.getEquipePrestataire(
      LISTE_EQUIPE_COORDO +
        "/" +
        id +
        `?param=${searchTerm}&page=${page}&size=10`,
    );
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    equipe.getEquipePrestataire(
      LISTE_EQUIPE_COORDO + "/" + id + `?param=${value}&page=0&size=10`,
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
      {/* Header avec retour et titre */}
      <div className="mb-8">
        <div className="flex items-center gap-4 mb-2">
          <button
            className="flex items-center justify-center w-10 h-10 rounded-xl bg-white shadow-sm hover:shadow-md transition-all duration-200 hover:scale-105"
            onClick={() => window.history.back()}
          >
            <CaretLeftIcon className="w-5 h-5 text-gray-700" />
          </button>
          <div>
            <h1 className="font-mtn text-3xl font-bold text-gray-900">
              Équipes de {name}
            </h1>
            <px className="text-sm text-gray-500 mt-1">
              Gérez les équipes et leurs membres
            </px>
          </div>
        </div>
      </div>

      {/* Modales */}
      <dialog id="associate_Team" className="modal rounded-none">
        <div className="modal-box w-11/12 max-w-2xl h-96 rounded-2xl shadow-2xl">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold font-mtn text-gray-900">
              Associer une équipe
            </h2>
            <form method="dialog">
              <button className="btn btn-sm btn-circle btn-ghost hover:bg-gray-100">
                <Cross2Icon className="w-5 h-5" />
              </button>
            </form>
          </div>
          <AssociateTeam id={Number(id)} />
        </div>
      </dialog>

      <dialog id="add_Team" className="modal rounded-none">
        <div className="modal-box w-11/12 max-w-2xl rounded-2xl shadow-2xl">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-2xl font-bold font-mtn text-gray-900">
              Ajouter une équipe
            </h2>
            <form method="dialog">
              <button className="btn btn-sm btn-circle btn-ghost hover:bg-gray-100">
                <Cross2Icon className="w-5 h-5" />
              </button>
            </form>
          </div>
          <AddTeam id={Number(id)} />
        </div>
      </dialog>

      {/* Barre de recherche et actions */}
      <div className="flex flex-col lg:flex-row gap-4 items-center mb-2">
        <div className="relative flex-1 w-full">
          <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            onChange={(e) => handleSearch(e.target.value)}
            type="text"
            placeholder="Rechercher une équipe..."
            className="input input-bordered px-3 pl-10 pr-10 w-full max-w-sm h-11 text-sm text-gray-900 placeholder:text-gray-400"
          />
        </div>
        <div className="flex gap-3 w-full lg:w-auto">
          <button
            onClick={() => document.getElementById("add_Team").showModal()}
            className="flex-1 lg:flex-initial flex items-center justify-center gap-2 px-6 py-2 bg-main  text-gray-900 rounded"
          >
            <Plus className="w-5 h-5" />
            <span>Ajouter</span>
          </button>
          <button
            onClick={() =>
              document.getElementById("associate_Team").showModal()
            }
            className="flex-1 lg:flex-initial flex items-center justify-center gap-2 px-6 py-2 bg-gray-900 hover:bg-gray-800 text-white rounded"
          >
            <Link2 className="w-5 h-5" />
            <span>Associer</span>
          </button>
        </div>
      </div>

      {/* Grille des équipes */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 gap-4 mb-6">
        {equipe?.loading ? (
          <Loader />
        ) : equipe?.equipePrestataire?.data?.length === 0 ? (
          <div className="col-span-full">
            <div className="bg-white rounded-2xl shadow-sm p-12 text-center">
              <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <UserMultipleIcon size={32} className="text-gray-400" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                Aucune équipe
              </h3>
              <p className="text-gray-500 mb-6">
                Commencez par ajouter ou associer une équipe
              </p>
              <button
                onClick={() => document.getElementById("add_Team").showModal()}
                className="btn bg-main hover:bg-main/90 text-gray-900 border-none"
              >
                <Plus className="w-5 h-5" />
                Ajouter une équipe
              </button>
            </div>
          </div>
        ) : (
          equipe?.equipePrestataire?.data?.map((item) => (
            <div
              key={item?.id}
              className="group relative bg-white rounded-lg transition-all duration-300 p-5 border border-gray-100"
            >
              {/* Menu dropdown */}
              <div className="dropdown dropdown-end absolute right-3 top-3 z-10">
                <div
                  tabIndex={0}
                  role="button"
                  className="w-8 h-8 rounded-lg flex items-center justify-center bg-gray-50 hover:bg-gray-100 transition-colors duration-200"
                >
                  <MoreHorizontal size={18} className="text-gray-600" />
                </div>
                <ul
                  tabIndex={0}
                  className="mt-2 dropdown-content z-[1] menu p-2 border border-gray-200 shadow-xl bg-white rounded-xl w-52"
                >
                  <li>
                    <NavLink
                      to={`${HOME}/equipes/${id}/detail-equipe/${
                        item?.equipe?.id
                      }/${encodeURIComponent(item?.equipe?.designation)}`}
                      className="hover:bg-gray-50 text-gray-700 rounded-lg px-4 py-3"
                    >
                      Voir les techniciens
                    </NavLink>
                  </li>
                  <li>
                    <div
                      onClick={() => {
                        document
                          .getElementById(`update_Team${item?.id}`)
                          .showModal();
                      }}
                      className="hover:bg-gray-50 text-gray-700 rounded-lg px-4 py-3 cursor-pointer"
                    >
                      Modifier
                    </div>
                  </li>
                  <li>
                    <div
                      onClick={() => {
                        disable(DISABLE_TEAM, item?.id).then((res) => {
                          if (res.status === 200) {
                            equipe.getEquipePrestataire(
                              LISTE_EQUIPE_COORDO +
                                "/" +
                                id +
                                `?param=${searchTerm}&page=0&size=10`,
                            );
                            toast.success(res.data.donnee);
                          }
                        });
                      }}
                      className={`rounded-lg px-4 py-3 cursor-pointer ${
                        item?.equipe?.isActif
                          ? "hover:bg-orange-50 hover:text-orange-600"
                          : "hover:bg-green-50 hover:text-green-600"
                      }`}
                    >
                      {item?.equipe?.isActif ? "Désactiver" : "Activer"}
                    </div>
                  </li>
                  <li>
                    <div
                      onClick={() => {
                        deleteOne(SUPPRIMER_EQUIPE, item?.equipe?.id).then(
                          (res) => {
                            if (res.status === 200) {
                              equipe.getEquipePrestataire(
                                LISTE_EQUIPE_COORDO +
                                  "/" +
                                  id +
                                  `?param=${searchTerm}&page=0&size=10`,
                              );
                              toast.success("Équipe retirée avec succès");
                            }
                          },
                        );
                      }}
                      className="hover:bg-red-50 hover:text-red-600 rounded-lg px-4 py-3 cursor-pointer"
                    >
                      Retirer l'équipe
                    </div>
                  </li>
                </ul>
              </div>

              {/* Modale de modification */}
              <dialog
                id={`update_Team${item?.id}`}
                className="modal rounded-none"
              >
                <div className="modal-box w-11/12 max-w-2xl rounded-2xl shadow-2xl">
                  <div className="flex items-center justify-between mb-6">
                    <h2 className="text-2xl font-bold font-mtn text-gray-900">
                      Modifier l'équipe
                    </h2>
                    <form method="dialog">
                      <button className="btn btn-sm btn-circle btn-ghost hover:bg-gray-100">
                        <Cross2Icon className="w-5 h-5" />
                      </button>
                    </form>
                  </div>
                  <UpdateTeam item={item} />
                </div>
              </dialog>

              {/* Contenu de la carte */}
              <div className="flex items-start gap-4">
                <div className="w-14 bg-gray-100 h-14 rounded-xl flex items-center justify-center ">
                  <UserMultipleIcon size={24} className="text-amber-600" />
                </div>
                <div className="flex-1 min-w-0 pt-1">
                  <h3 className="font-semibold text-gray-900 text-lg mb-2 truncate">
                    {item?.equipe?.designation}
                  </h3>
                  <span
                    className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
                      item?.equipe?.isActif
                        ? "bg-green-100 text-green-700"
                        : "bg-red-100 text-red-700"
                    }`}
                  >
                    {item?.equipe?.isActif ? "Actif" : "Inactif"}
                  </span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Pagination */}
      {equipe?.equipePrestataire?.data?.length > 0 && (
        <div className="flex justify-center">
          <div className="bg-white rounded-xl shadow-sm px-4 py-3">
            <Pagination
              onChange={(event, newValue) => more(newValue - 1)}
              count={equipe?.equipePrestataire?.totalPages}
              variant="outlined"
              color="primary"
              shape="rounded"
              size="large"
            />
          </div>
        </div>
      )}
    </div>
  );
};
